// extracted by mini-css-extract-plugin
export var headerCell = "_5t-1";
export var loadingStateCell = "_5t-4";
export var rowWrapper = "_5t-3";
export var standaloneTable = "_5t-5";
export var table = "_5t-0";
export var white = "_5t-2";